export const transactionSchema = ({list}) => {
    const {
        items: notApplicableList,
        status: notApplicableListStatus,
    } = list.notApplicable;

    return (
        {
            transactionType: {
                type: 'select',
                label: 'Transaction Type',
                isSearch: true,
                options: notApplicableListStatus === "success" ? notApplicableList : {},
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value === '') return 'Transaction type is required';
                    return null;
                },
            },
            transactionDate: {
                type: 'date',
                label: 'Transaction Date',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Transaction date is required';
                    return null;
                },
            },
            amount: {
                type: 'text',
                label: 'Amount',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (String(value).trim() === '') return 'Amount is required';
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            }
        }
    )
}
